import React, { useRef, useEffect } from "react";
import Textbox from "carbon-react/lib/__experimental__/components/textbox";
import StepTitle from "../../common/stepTitle/StepTitle";
import DialogConfirmButtons from "../../common/dialogConfirmButtons/DialogConfirmButtons";
import SuccessMessage from "../../messages/SuccessMessage";

const EnterCodeStep = ({
  user,
  busy,
  state,
  onStateChanged,
  onCancel,
  onCompleted,
}) => {
  const validationCodeInputRef = useRef(null);

  useEffect(() => {
    //  Set focus to the validation code input element
    if (!busy && isAValidFunc(validationCodeInputRef?.current?.focus)) {
      validationCodeInputRef.current.focus();
    }
  }, [busy]);

  const isAValidFunc = (func) => {
    return func && typeof func === "function";
  };

  const onCancelClicked = () => {
    if (isAValidFunc(onCancel)) onCancel();
  };

  const onVerifyEmailAccessClicked = () => {
    if (!validateStep()) return;
    if (isAValidFunc(onCompleted)) onCompleted();
  };

  const validateStep = () => {
    let result = true;
    if (!validateVerificationCode()) result = false;
    return result;
  };

  const validateVerificationCode = () => {
    const valid =
      state.verificationCode && state.verificationCode.length > 0
        ? true
        : false;
    updateState(() => {
      state.verificationCodeValid = valid;
    });
    return valid;
  };

  const verificationCodeWarningAttributes = {
    hasWarning: true,
    inputIcon: "warning",
    tooltipMessage: "Please enter a valid code",
  };

  const onVerificationCodeChanged = (code) => {
    const sanitizedCode = code && code.length > 0 ? code.trim() : "";
    updateState(() => {
      state.verificationCode = sanitizedCode;
      state.verificationCodeValid = true;
    });
  };

  const updateState = (mutateState) => {
    if (isAValidFunc(mutateState)) mutateState();
    onStateChanged({ ...state });
  };

  const verificationCodeInput = (
    <div className="verify-email-access-verification-code">
      <Textbox
        id="verify-email-access-verification-code"
        label="Verification code"
        disabled={busy}
        value={state?.verificationCode}
        inputRef={(e) => {
          validationCodeInputRef.current = e?.current;
        }}
        onChange={(e) => {
          onVerificationCodeChanged(e.target.value);
        }}
        onBlur={validateVerificationCode}
        {...(!state.verificationCodeValid
          ? verificationCodeWarningAttributes
          : {})}
      />
    </div>
  );

  const buttons = (
    <DialogConfirmButtons
      appearBusy={busy}
      confirmBtnEnabled={true}
      confirmBtnLabel="Confirm"
      onConfirm={onVerifyEmailAccessClicked}
      onCancel={onCancelClicked}
    />
  );

  return (
    <div id="enter-code-step" className="verify-email-access-enter-code-step">
      <div className="verify-email-access-step-body">
        <SuccessMessage
          className="code-sent-success-message"
          message={`Verification code was sent to ${user?.email}.`}
        />
        <StepTitle title="Enter verification code" />
        {verificationCodeInput}
      </div>
      {buttons}
    </div>
  );
};

export default EnterCodeStep;
